import React from 'react';
import { BookOpen, Code2, PenTool, CheckCircle2 } from 'lucide-react';
export function CertificationSteps() {
  return <div className="w-full max-w-6xl mx-auto px-4 py-12 md:py-20" data-id="element-1">
      <div className="text-center mb-10 md:mb-16" data-id="element-2">
        <h2 className="text-3xl md:text-5xl font-display font-bold text-gray-900" data-id="element-3">
          Steps to <span className="text-laravel-red" data-id="element-4">Certification</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-5">
        {/* Step 1 */}
        <div className="bg-card border border-cardBorder rounded-3xl p-8 shadow-md" data-id="element-6">
          <div className="text-laravel-red font-bold text-sm tracking-widest mb-6 uppercase" data-id="element-7">
            Step 1
          </div>
          <div className="flex items-start gap-6" data-id="element-8">
            <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-9">
              <BookOpen className="w-6 h-6 text-laravel-red" data-id="element-10" />
            </div>
            <div data-id="element-11">
              <h3 className="text-2xl font-display font-bold mb-3 text-gray-900" data-id="element-12">
                Exam Preparation
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm md:text-base" data-id="element-13">
                Review the preparation guide to understand the domains, skills,
                and expectations for your chosen level.
              </p>
            </div>
          </div>
        </div>

        {/* Step 2 */}
        <div className="bg-card border border-cardBorder rounded-3xl p-8 shadow-md" data-id="element-14">
          <div className="text-laravel-red font-bold text-sm tracking-widest mb-6 uppercase" data-id="element-15">
            Step 2
          </div>
          <div className="flex items-start gap-6" data-id="element-16">
            <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-17">
              <Code2 className="w-6 h-6 text-laravel-red" data-id="element-18" />
            </div>
            <div data-id="element-19">
              <h3 className="text-2xl font-display font-bold mb-3 text-gray-900" data-id="element-20">
                Optional Training
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm md:text-base" data-id="element-21">
                Use self-study resources and practice exams to close knowledge
                gaps. Teams can also standardize prep with internal study
                sessions.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Step 3 - Full Width */}
      <div className="bg-card border border-cardBorder rounded-3xl p-8 overflow-hidden relative shadow-md" data-id="element-22">
        <div className="text-laravel-red font-bold text-sm tracking-widest mb-6 uppercase" data-id="element-23">
          Step 3
        </div>
        <div className="flex items-start gap-6 mb-12" data-id="element-24">
          <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-25">
            <PenTool className="w-6 h-6 text-laravel-red" data-id="element-26" />
          </div>
          <div data-id="element-27">
            <h3 className="text-2xl font-display font-bold mb-3 text-gray-900" data-id="element-28">
              Take Examination
            </h3>
            <p className="text-gray-600 leading-relaxed text-sm md:text-base max-w-4xl" data-id="element-29">
              Complete the online proctored certification exam, typically
              combining knowledge-based questions with practical,
              scenario-driven tasks (level dependent).
            </p>
          </div>
        </div>

        {/* Mock UI Recreation - Light Theme */}
        <div className="flex flex-col md:flex-row gap-6 mt-8 bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-30">
          {/* Left Mock Panel */}
          <div className="bg-white rounded-2xl p-6 border border-gray-200 flex-1 max-w-sm shadow-sm" data-id="element-31">
            <div className="flex items-center gap-3 mb-4" data-id="element-32">
              <div className="w-4 h-4 rounded-full bg-laravel-red" data-id="element-33"></div>
              <div className="h-2 w-16 bg-gray-200 rounded-full" data-id="element-34"></div>
            </div>
            <div className="text-laravel-red font-mono text-xl font-bold mb-2" data-id="element-35">
              00:23:22
            </div>
            <div className="h-2 w-12 bg-gray-200 rounded-full" data-id="element-36"></div>
          </div>

          {/* Middle Mock Panel */}
          <div className="bg-white rounded-2xl p-6 border border-gray-200 flex-[2] shadow-sm" data-id="element-37">
            <div className="flex items-center gap-3 mb-8" data-id="element-38">
              <div className="w-4 h-4 rounded bg-laravel-red" data-id="element-39"></div>
              <div className="h-2 w-32 bg-gray-200 rounded-full" data-id="element-40"></div>
            </div>

            <div className="space-y-4" data-id="element-41">
              <div className="flex items-center gap-4" data-id="element-42">
                <CheckCircle2 className="w-5 h-5 text-laravel-red" data-id="element-43" />
                <div className="h-3 w-full max-w-[200px] bg-laravel-red rounded-full" data-id="element-44"></div>
              </div>
              <div className="flex items-center gap-4" data-id="element-45">
                <div className="w-5 h-5 rounded-full border-2 border-gray-300" data-id="element-46"></div>
                <div className="h-3 w-full max-w-[150px] bg-gray-200 rounded-full" data-id="element-47"></div>
              </div>
              <div className="flex items-center gap-4" data-id="element-48">
                <div className="w-5 h-5 rounded-full border-2 border-gray-300" data-id="element-49"></div>
                <div className="h-3 w-full max-w-[180px] bg-gray-200 rounded-full" data-id="element-50"></div>
              </div>
            </div>
          </div>

          {/* Right Mock Panel */}
          <div className="bg-white rounded-2xl p-6 border border-gray-200 flex-[2] flex gap-4 shadow-sm" data-id="element-51">
            <div className="flex-1" data-id="element-52">
              <div className="flex items-center gap-3 mb-4" data-id="element-53">
                <div className="w-4 h-4 rounded bg-laravel-red" data-id="element-54"></div>
                <div className="h-2 w-20 bg-gray-200 rounded-full" data-id="element-55"></div>
              </div>
              <div className="h-1 w-8 bg-laravel-red rounded-full mb-6" data-id="element-56"></div>
              <div className="space-y-3" data-id="element-57">
                <div className="h-2 w-full bg-gray-200 rounded-full" data-id="element-58"></div>
                <div className="h-2 w-5/6 bg-gray-200 rounded-full" data-id="element-59"></div>
                <div className="h-2 w-4/6 bg-gray-200 rounded-full" data-id="element-60"></div>
                <div className="h-2 w-full bg-gray-200 rounded-full" data-id="element-61"></div>
              </div>
            </div>

            <div className="flex-[1.5] bg-gray-50 rounded-xl p-4 border border-gray-200" data-id="element-62">
              <div className="w-6 h-6 rounded bg-red-100 flex items-center justify-center mb-6" data-id="element-63">
                <Code2 className="w-4 h-4 text-laravel-red" data-id="element-64" />
              </div>
              <div className="space-y-3" data-id="element-65">
                <div className="h-2 w-32 bg-laravel-red rounded-full" data-id="element-66"></div>
                <div className="h-2 w-48 bg-gray-300 rounded-full ml-4" data-id="element-67"></div>
                <div className="h-2 w-40 bg-gray-300 rounded-full ml-4" data-id="element-68"></div>
                <div className="h-2 w-56 bg-gray-300 rounded-full ml-8" data-id="element-69"></div>
                <div className="h-2 w-24 bg-laravel-red rounded-full" data-id="element-70"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}